import { css } from 'lit';
import { effectStyles } from '../../styles/effectStyles.js';
import { BaseGenericElement } from './BaseElement.js';

export class BaseAtomElement extends BaseGenericElement {
  override connectedCallback(): void {
    super.connectedCallback();

    const wrapper = this.closest('veneer-skeleton');
    this.setAttribute('theme-shape', wrapper?.shape ?? '');
    this.setAttribute('theme-alignment', wrapper?.alignment ?? '');
    this.setAttribute('effect', wrapper?.effect ?? '');
  }

  static override styles = [
    effectStyles,
    css`
      :host {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: flex-start;
        -webkit-align-items: flex-start;
        justify-content: flex-start;
        -webkit-align-content: flex-start;
      }
      :host > div {
        display: block;
      }
      :host([theme-alignment='center']) {
        align-items: center;
        -webkit-align-items: center;
        align-content: center;
        -webkit-align-content: center;
      }
      :host([theme-alignment='end']) {
        align-items: flex-end;
        -webkit-align-items: flex-end;
        align-content: flex-end;
        -webkit-align-content: flex-end;
      }
      :host([alignment='center']) {
        align-items: center;
        -webkit-align-items: center;
        align-content: center;
        -webkit-align-content: center;
      }
      :host([alignment='end']) {
        align-items: flex-end;
        -webkit-align-items: flex-end;
        align-content: flex-end;
        -webkit-align-content: flex-end;
      }
      ::slotted(*) {
        clip: rect(0 0 0 0); /* IE6, IE7 */
        clip: rect(0, 0, 0, 0);
        clip-path: inset(50%); /* browsers in the future */
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
        top: auto;
      }
    `,
  ];
}
